{
  "move_node": {
    "title": "Choose a new location for the {{ nodeType }}",
    "multi_title": "Choose a new location for the {{ count }} selected items",
    "empty_title": "Choose a new location",
    "success": "The item(s) have been moved successfully.",
    "multiple_items": "Multiple items",
    "no_permission_tooltip": "You do not have permission to move items to this location"
  },
  "permissions": {
    "request_access": "Request access",
    "no_read_permissions": "You do not have read permissions on this item",
    "no_write_permissions": "You do not have write permissions on this item"
  },
  "mappingLibraries": {
    "My Workspace": "My Workspace",
    "My workspace": "My Workspace",
    "Team Workspace": "Team Workspace",
    "Team workspace": "Team Workspace",
    "Shared library": "Team Workspace",
    "Recently viewed": "Recently Viewed",
    "Recently Viewed": "Recently Viewed",
    "Favourites": "Favourites",
    "add_to_favourites": "add to favourites",
    "remove_from_favourites": "remove from favourites"
  },
  "copy_node": {
    "button": "Copy {{ nodeType }}",
    "title": "Choose a location to copy the {{ nodeType }}",
    "multi_title": "Choose a location to copy the selected items",
    "empty_title": "Choose a location",
    "success": "The item(s) have been copied successfully.",
    "multiple_items": "Multiple items",
    "no_permission_tooltip": "You do not have permission to copy items to this location",
    "copy_with_map_objects": "Copy map objects",
    "options_title": "Copy Options",
    "options_submit_button": "Copy",
    "options_description": {
      "map_objects_only": "Choose whether to include map objects when copying.",
      "map_objects_and_permissions": "Choose whether to include map objects and permissions when copying."
    }
  },
  "delete_node": {
    "selected_items_cannot_be_deleted": "You cannot delete the selected item(s)"
  },
  "create_node": {
    "change_location": "Change location"
  }
}